import styled from '@emotion/styled';

import theme from 'theme';

import {SnackbarVariant} from '../types';

import type {RequiredQA} from 'common';
import type {SnackbarContentProps, SnackbarMessageInner} from '../types';

const variantColor: Record<SnackbarVariant, string> = {
  [SnackbarVariant.Default]: theme.colors.white,
  [SnackbarVariant.Success]: theme.colors.additional.green[50],
  [SnackbarVariant.Warning]: theme.colors.additional.yellow[50],
  [SnackbarVariant.Error]: theme.colors.additional.red[50],
};

const Container = styled.div`
  padding: 6px 8px 6px 4px;
`;

const TitleComponent = styled.div<Pick<SnackbarMessageInner, 'variant'>>`
  padding-bottom: 2px;
  color: ${props => variantColor[props.variant]};

  ${theme.typography.h4}
`;

const ContentComponent = styled.div`
  color: ${theme.colors.white};

  ${theme.typography.p1compact}
`;

export const MessageContent: React.FC<SnackbarContentProps & RequiredQA> = ({message, qa}) => {
  const {title, content, variant, whiteSpace} = message;

  return (
    <Container data-qa={`${qa}-message`}>
      {title && <TitleComponent variant={variant}>{title}</TitleComponent>}
      <ContentComponent style={{whiteSpace}}>{content}</ContentComponent>
    </Container>
  );
};
